// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"d56131a5","502":"a3f6b268","530":"0093d75a","736":"44cc220c"}[chunkId] + ".css";
};